var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFireSafety(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 14.5C26.5465 14.5 25.3068 15.4495 24.8354 16.75H23.5C20.4119 16.75 17.875 19.2869 17.875 22.375H20.125C20.125 20.5131 21.6381 19 23.5 19H24.625V21.7788C24.265 22.0454 23.8004 22.4256 23.2525 22.9712C22.3232 23.905 21.25 25.1875 21.25 26.875V41.5H34.75V26.875C34.75 25.1875 33.6779 23.905 32.7475 22.9712C32.1996 22.4256 31.735 22.0454 31.375 21.7788V21.4604L36.8245 22.375L38.125 22.5865V15.4135L36.8245 15.625L31.0938 16.5745C30.5785 15.3662 29.3883 14.5 28 14.5ZM28 16.75C28.6244 16.75 29.125 17.2506 29.125 17.875V21.25H26.875V17.875C26.875 17.2506 27.3756 16.75 28 16.75ZM35.875 18.0865V19.9146L31.375 19.1406V18.8594L35.875 18.0854V18.0865ZM26.1719 23.5H29.8281C29.9969 23.6181 30.4784 23.9388 31.1286 24.5913C31.8857 25.345 32.5011 26.3125 32.5011 26.875V39.25H23.5011V26.875C23.5011 26.3125 24.1165 25.345 24.8736 24.5913C25.5227 23.9388 26.0031 23.6181 26.173 23.5H26.1719ZM25.75 29.125V31.375H30.25V29.125H25.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireSafety);
export default __webpack_public_path__ + "static/media/fireSafety.07e37a3a192cf278633000d49ed38dbb.svg";
export { ForwardRef as ReactComponent };